import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "mail",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M2.5 6.66602L9.075 11.0493C9.34888 11.2321 9.67075 11.3296 10 11.3296C10.3292 11.3296 10.6511 11.2321 10.925 11.0493L17.5 6.66602M4.16667 15.8327H15.8333C16.2754 15.8327 16.6993 15.6571 17.0118 15.3445C17.3244 15.032 17.5 14.608 17.5 14.166V5.83268C17.5 5.39065 17.3244 4.96673 17.0118 4.65417C16.6993 4.34161 16.2754 4.16602 15.8333 4.16602H4.16667C3.72464 4.16602 3.30072 4.34161 2.98816 4.65417C2.67559 4.96673 2.5 5.39065 2.5 5.83268V14.166C2.5 14.608 2.67559 15.032 2.98816 15.3445C3.30072 15.6571 3.72464 15.8327 4.16667 15.8327Z",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgMail;
